export default {
    API_BASE_URL: "https://api.dh-thailand.com/graphql",
    FRONT_ORDER_URL: "https://order.dh-thailand.com/",
    FRONT_BOOKING_URL: "https://booking.dh-thailand.com/",
    WORK_INFINITY_OAUTH:
        "https://staff.workinfinityx.com/oauth?client_id=633ceb8e49da3d5bb4c3928f",
};
